// extracted by mini-css-extract-plugin
module.exports = {"cardOverlay":"Card_cardOverlay__PHh6W","cardSize":"Card_cardSize__Ix44k"};